import { useThor } from "../context/ThorContext";

const TOAST_COLORS = {
    success: 'is-success',
    danger: 'is-danger',
    warning: 'is-warning',
    info: 'is-info',
};

const ThorToast = () => {
    const { toasts, dismissToast } = useThor();
    if (!toasts.length) return null;
    return (
        <div aria-live="polite" role="status" style={{
            position: 'fixed', bottom: '1.5rem', right: '1.5rem',
            zIndex: 9999, display: 'flex', flexDirection: 'column',
            gap: '0.5rem', maxWidth: '420px',
        }}>
            {toasts.map(t => (
                <div key={t.id}
                     className={`notification ${TOAST_COLORS[t.type] ?? 'is-info'}`}
                     role={t.type === 'danger' || t.type === 'error' ? 'alert' : undefined}
                     style={{ margin: 0 }}>
                    <button className="delete" onClick={() => dismissToast(t.id)} />
                    {t.message}
                </div>
            ))}
        </div>
    );
};

export default ThorToast;
